import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import Image from "next/legacy/image";
import { type CaseStudySimple } from "lib/sanity";
import { ArrowLink } from "ui/link";
import { LinkCard } from "ui/link-card";

export function CustomerCard({
  imageUrl,
  title,
  customerSlug,
  customerName,
  customerLogo,
  customerLogoMono,
}: CaseStudySimple) {
  return (
    <LinkCard
      key={customerSlug}
      href={`/customers/${customerSlug}`}
      linkAriaLabel={`Read ${title}.`}
      cursor="pointer"
      pos="relative"
      height="500px"
      p={0}
      borderRadius="base"
      overflow="hidden"
      _after={{
        position: "absolute",
        content: "''",
        opacity: 0.9,
        h: "100%",
        w: "100%",
        bg: "forest",
        transition: "100ms all",
      }}
      _hover={{
        _after: {
          opacity: 0.95,
        },
      }}
    >
      <Box pos="relative" width="100%" height="100%">
        <Image src={imageUrl + "?w=700"} alt={title + "."} layout="fill" objectFit="cover" />
      </Box>

      <Flex direction="column" align="start" pos="absolute" top={0} left={0} height="100%" zIndex={1} p={8}>
        <Box pos="relative" filter="brightness(0) invert(1)" width="100%" maxWidth="50%" height="36px" mb="bigger">
          <Image
            src={`${customerLogoMono ?? customerLogo}?w=200`}
            alt={customerName + "."}
            layout="fill"
            objectFit="contain"
            objectPosition="left"
          />
        </Box>

        <Text as="h2" mb={6} fontSize="2xl" fontWeight="semibold" color="white">
          {title}
        </Text>

        <ArrowLink variant="mint" size="xl" mt="auto">
          Read the story
        </ArrowLink>
      </Flex>
    </LinkCard>
  );
}
